<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent mb-4">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.userManagement') }}
                    </h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-xl-4" v-if="(hasPraticienRole || hasMedecinControleRole || hasAssistante)">
                    <router-link :to="{ name: 'managers' }">
                        <stats-card
                                :title="$tc('message.managers', 2)"
                                type="gradient-teal"
                                icon="fas fa-users-cog"
                                class="mb-4"
                        ></stats-card>
                    </router-link>
                </div>

                <div class="col-lg-4 col-xl-4" v-if="(can && userIsMed || hasAssistante) || ((hasPraticienRole || hasMedecinControleRole ) && userIsMed) ">
                    <router-link :to="{ name: 'subscribers' }">
                        <stats-card
                                :title="$tc('message.subscribers', 2)"
                                type="gradient-orange"
                                icon="fas fa-user"
                                class="mb-4"
                        ></stats-card>
                    </router-link>
                </div>

                <div class="col-lg-4 col-xl-4" v-if="can || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                    <router-link :to="{ name: 'patients' }">
                        <stats-card
                                :title="$tc('message.patients', 2)"
                                type="gradient-red"
                                icon="fas fa-user-injured"
                                class="mb-4"
                        ></stats-card>
                    </router-link>
                </div>

                <div class="col-lg-4 col-xl-4" v-if="hasMedecinControleRole || hasAssistante">
                    <router-link :to="{ name: 'control-doctors' }">
                        <stats-card
                                :title="$tc('message.controlDoctors', 2)"
                                type="gradient-green"
                                icon="fas fa-user-md"
                                class="mb-4 mb-xl-0"
                        ></stats-card>
                    </router-link>
                </div>

                <div class="col-lg-4 col-xl-4" v-if="can || hasAssistante">
                    <router-link :to="{ name: 'practitioners' }">
                        <stats-card
                                :title="$tc('message.practitioners', 2)"
                                type="gradient-purple"
                                icon="fas fa-user-nurse"
                                class="mb-4 mb-xl-0"
                        ></stats-card>
                    </router-link>
                </div>

                <div class="col-lg-4 col-xl-4" >
                    <router-link :to="{ name: 'partners' }">
                        <stats-card
                                :title="$tc('message.partner', 2)"
                                type="gradient-purple"
                                icon="fas fa-user-nurse"
                                class="mb-4 mb-xl-0"
                        ></stats-card>
                    </router-link>
                </div>
                <div class="col-lg-4 col-xl-4" v-if="hasGestionnaireRole || hasMedecinControleRole || hasAssistante">
                    <router-link :to="{ name: 'associations' }">
                        <stats-card
                                :title="$tc('message.association', 2)"
                                type="gradient-yellow"
                                icon="fas fa-hands-helping"
                                class="mb-4 mb-xl-0"
                        ></stats-card>
                    </router-link>
                </div>
                <div class="col-lg-4 col-xl-4" v-if="hasGestionnaireRole || hasAdminRole">
                    <router-link :to="{ name: 'assistants' }">
                        <stats-card
                                :title="$tc('message.assistante', 2)"
                                type="gradient-yellow"
                                icon="fas fa-hands-helping"
                                class="mb-4 mb-xl-0"
                        ></stats-card>
                    </router-link>
                </div>
                <div class="col-lg-4 col-xl-4" v-if="hasGestionnaireRole || hasAdminRole">
                    <router-link :to="{ name: 'groupes' }">
                        <stats-card
                                :title="$tc('message.groupes', 2)"
                                type="gradient-yellow"
                                icon="fas fa-users"
                                class="mb-4 mb-xl-0"
                        ></stats-card>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "UserManagement",
        computed: {
            ...mapGetters([
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasPatientRole',
                'hasPraticienRole',
                'hasSouscripteurRole',
                'hasGestionnaireRole',
                'hasAssistante']),

            can:function () {
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },
        },


    }
</script>

<style scoped>

</style>